export const canHandleApplePay = () => {
  return window.ApplePaySession && ApplePaySession.canMakePayments();
};
